/* eslint-disable multiline-ternary */
import React from 'react'
import { Typography } from '@mui/material'
import { pluralize } from '../../helpers/plural'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  term: {
    fontWeight: 700
  },
  sorry: {
    marginBottom: spacing(1),
    fontWeight: 700
  }
}))

const NoResultsHeader = ({ term, ...props }) => {
  const classes = useStyles()
  return (
    <div {...props}>
      <Typography
        variant='h3'
        component='h1'
        className={classes.sorry}
        data-test='serp-header'
      >
        We&apos;re sorry.
      </Typography>
      {term ? (
        <>
          <Typography variant='body1' display='inline'>
            No results were found for{' '}
          </Typography>
          <Typography
            variant='body1'
            display='inline'
            className={classes.term}
            data-test='serp-header-term'
          >
            &apos;{term}&apos;
          </Typography>
        </>
      ) : (
        <Typography variant='body1'>No search term found</Typography>
      )}
    </div>
  )
}

const ResultsHeader = ({ term, total, ...props }) => {
  const classes = useStyles()

  const text = () =>
    `${total} ${pluralize('result', total)} ${term ? 'for' : ''}`

  return (
    <div {...props}>
      <Typography variant='body1' component='h1' data-test='serp-header-text'>
        {text()}
      </Typography>
      {!!term && (
        <Typography
          variant='h4'
          component='h2'
          className={classes.term}
          data-test='serp-header-term'
        >
          &apos;{term}&apos;
        </Typography>
      )}
    </div>
  )
}

const Header = props =>
  props.total > 0 ? (
    <ResultsHeader {...props} />
  ) : (
    <NoResultsHeader {...props} />
  )

export default Header
